import { useMemo } from "react";
import { useClientViewSeo } from "../clientViewRuntime/hooks/useClientViewSeo";
import { buildGlobalStructuredData } from "./structuredData";

/**
 * Global Organization + WebSite JSON-LD for AutoMapa public pages (Milestone 14).
 * TODO(M15 Analytics): Track SEO route views separately from page metadata.
 */
export default function AutomapGlobalSeo() {
  const structuredData = useMemo(() => buildGlobalStructuredData(), []);

  useClientViewSeo({
    structuredData,
    jsonLdId: "automap-global-jsonld",
  });

  return null;
}
